/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';

import { maskable } from 'utils/maskableText';

import styles from './ElectroTextField.module.scss';

/**
 * Fields:
 * field: required. example: form.$('additionalInfo.comments')
 */
const ElectroTextField: React.StatelessFunctionalComponent<*> = observer(
  ({
    field,
    props,
    margin,
    readonly,
    className,
    disabled,
    onKeyPress,
    onKeyUp,
    mask,
    required,
  }: Object) => {
    const inputProps = {
      readOnly: readonly ? 1 : false,
      onKeyPress,
      onKeyUp,
    };
    const isInputRequired = required
      ? required
      : Boolean(field.rules && field.rules.includes('required'));
    return (
      <TextField
        {...field.bind()}
        {...props}
        error={field.showError && field.hasError}
        className={styles['electro-text-field']}
        helperText={
          field.showError && field.error
            ? field.error
            : field.extra && field.extra.helperText
            ? field.extra.helperText
            : ''
        }
        required={isInputRequired}
        margin="none"
        disabled={disabled || field.disabled}
        inputProps={inputProps}
        value={
          disabled && mask
            ? maskable(
                (field.value && field.value.toLocaleString()) || '',
                mask.type,
                mask.shouldMask
              )
            : (field.value && field.value.toLocaleString()) || ''
        }
      />
    );
  }
);

ElectroTextField.propTypes = {
  field: PropTypes.object.isRequired,
};

export default ElectroTextField;
